import { render } from "./VirtualPackingSlipShipmentDetails.vue?vue&type=template&id=d653fa84&scoped=true"
import script from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js"
export * from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js"

import "./VirtualPackingSlipShipmentDetails.vue?vue&type=style&index=0&id=d653fa84&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d653fa84"]])

export default __exports__